export const ASSINATURA = () => `/assinatura`;
